import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../auth/auth.service';

const ROUTE_MODULE_MAP: { module: string; route: string }[] = [
  { module: 'dashboard_menu',         route: '/dashboard' },
  { module: 'business_menu',          route: '/business' },
  { module: 'business_location_menu', route: '/stores' },
  { module: 'subscription_menu',      route: '/subscriptions' },
  { module: 'packages_menu',          route: '/roles-permissions/list-package' },
  { module: 'human_resource_menu',    route: '/HR/employee' },
  { module: 'learning_management',    route: '/learning-management/training/TrainingCategory' },
  { module: 'document_control_menu',  route: '/document-control/drive' },
  { module: 'asset_management_menu',  route: '/asset-management/alerts' },
  { module: 'task_management_menu',   route: '/task-management/my-tasks' },
  { module: 'discount_menu',          route: '/discount' },
  { module: 'comission_menu',         route: '/commission' },
  { module: 'sale_goals_menu',        route: '/sales-goals' },
  { module: 'authenticator_menu',     route: '/authenticator' },
  { module: 'master_data_menu',       route: '/master-data' },
  { module: 'region_menu',            route: '/franchisor-region' },
  { module: 'notification_menu',            route: '/notification' },
];

function getFirstAllowedRoute(authService: AuthService, currentUrl?: string): string | null {
  const allowed = authService.allowedModules();
  return (
    ROUTE_MODULE_MAP.find(
      ({ module, route }) =>
        allowed.includes(module) && (!currentUrl || !currentUrl.startsWith(route)),
    )?.route ?? null
  );
}

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const authService = inject(AuthService);
  const router      = inject(Router);

  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }

  const data             = route.data as Record<string, string>;
  const hasPermissionData = !!(data && Object.keys(data).length > 0);

  const denied = () => {
    const firstRoute = getFirstAllowedRoute(authService, state.url);
    if (!firstRoute) {
      return router.createUrlTree(['/login']);
    }
    return router.createUrlTree([firstRoute]);
  };

  const proceedWithPermissions = () => {
    const user = authService.getUser();
    if (user?.business_status === 'inprogress') {
      if (state.url.includes('subscriptions/request')) return of(true);
      // localStorage.clear();
      authService.clearPermissions();
      return of(router.createUrlTree(['/login']));
    }

    if (!hasPermissionData) return of(true);

    if (authService.permissionsLoaded()) {
      return of(authService.validatePermission(data) ? true : denied());
    }

    return authService.loadPermissions().pipe(
      map(() => (authService.validatePermission(data) ? true : denied())),
      catchError(() => of(denied())),
    );
  };

  return proceedWithPermissions();
};
